module.exports = __webpack_public_path__ + "static/img/projecteur.8ffbd1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/projecteur.jpg
// module id = 35
// module chunks = 0